import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import type { Me } from '../api';
import { FF_ENV } from '../api';

export function Layout({ me, onLogout, children }: {
  me: Me | null;
  onLogout?: () => void;
  children: ReactNode;
}) {
  return (
    <>
      <header
        style={{
          borderBottom: 'var(--line)',
          background: 'rgba(255,255,255,.86)',
          backdropFilter: 'saturate(1.4) blur(8px)',
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        <div
          style={{
            maxWidth: '64rem', margin: '0 auto', padding: '.75rem 1.5rem',
            display: 'flex', alignItems: 'center', gap: '.9rem',
          }}
        >
          <Link
            to="/clients"
            style={{ display: 'flex', alignItems: 'center', gap: '.6rem', borderBottom: 0 }}
          >
            <img src="/logo.svg" alt="Fiscal Founders" width={24} height={24} />
            <span style={{ fontFamily: 'var(--serif)', fontSize: '1.1rem', color: 'var(--ink)', letterSpacing: '-.01em' }}>
              Close Agent
            </span>
          </Link>

          {/* The environment is always visible: dev and prod look identical and
              acting on the wrong one is an expensive mistake. */}
          {FF_ENV !== 'prod' && <span className="chip">{FF_ENV}</span>}

          {me?.activeFirm && (
            <div className="row row-end" style={{ gap: '.9rem' }}>
              <div style={{ textAlign: 'right', lineHeight: 1.3 }}>
                <div style={{ fontWeight: 600, fontSize: '.875rem' }}>{me.activeFirm.name}</div>
                <div className="muted" style={{ fontSize: '.78rem' }}>{me.user.email}</div>
              </div>
              {onLogout && (
                <>
                  <span aria-hidden="true" style={{ width: 1, height: '1.8rem', background: 'var(--putty)' }} />
                  <button className="link" onClick={onLogout}>Sign out</button>
                </>
              )}
            </div>
          )}
        </div>
      </header>

      <main style={{ maxWidth: '64rem', margin: '0 auto', padding: '2.4rem 1.5rem 5rem' }}>
        {children}
      </main>
    </>
  );
}
